(function(){
     'use strict';

     angular
        .module('appback')
        .factory('FavoritasService', FavoritasService);

    FavoritasService.$inject = ['$http'];

    function FavoritasService($http){

        var service= {
           marcar:marcar
        };

        return service;
 		function marcar(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               filtros:JSON.stringify(filtros)
            });
            $http.post('/backend/favoritas/marcar', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

      
    }
})();